module.exports = __webpack_public_path__ + "img/16d001-14.48c345d4.png";